<div class="app-component-container" id="contact">
    <div class="content">
        <app-s-header [elemIds]="elementSignals['component-header']()"></app-s-header>
    </div>
    <app-contact-form></app-contact-form>
</div>